// extracted by mini-css-extract-plugin
export default {"component":"ProfileNew_component__i+NuW","dstv_logo":"ProfileNew_dstv_logo__AfCga","title":"ProfileNew_title__wdwE+","action__container":"ProfileNew_action__container__28eki"};